var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.924,
    height: 22.925,
    viewBox: "0 0 22.924 22.925",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_175",
    "data-name": "Trazado 175",
    d: "M671.462,166a11.462,11.462,0,1,0,11.462,11.462A11.475,11.475,0,0,0,671.462,166Zm3.179,6.8a.173.173,0,0,1-.173.174h-1.378a.612.612,0,0,0-.612.612v1.443h1.96a.173.173,0,0,1,.172.188l-.172,2.034a.173.173,0,0,1-.172.159h-1.788v6.752a.173.173,0,0,1-.174.173h-2.467a.173.173,0,0,1-.173-.173v-6.752h-1.234a.173.173,0,0,1-.173-.173V175.2a.174.174,0,0,1,.173-.173h1.234v-1.961a2.474,2.474,0,0,1,2.475-2.475h2.329a.173.173,0,0,1,.173.173Z",
    transform: "translate(-660 -166)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.34774c31aa812f48f8e450483a40fedd.svg";
export { ForwardRef as ReactComponent };